import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { companyList } from 'actions/company';

import { Link } from 'react-router';
import NotFound from 'components/NotFound';
import NavBarConfig from '../../components/NavBarConfig';
import CompanyList from '../../components/company/CompanyList';

import Logo from '../../components/Logo';

const messages = defineMessages({
  ALL_COMPANIES: {
    id: 'CompanyListPage.ALL_COMPANIES',
    defaultMessage: 'Alle Unternehmen',
  },
  CREATE_COMPANY: {
    id: 'CompanyListPage.CREATE_COMPANY',
    defaultMessage: 'Unternehmen anlegen',
  },
  MAINTAIN_USER: {
    id: 'CompanyListPage.MAINTAIN_USER',
    defaultMessage: 'Benutzer verwalten',
  },
  ADMIN_DASHBOARD: {
    id: 'CompanyListPage.ADMIN_DASHBOARD',
    defaultMessage: 'Admin Dashboard',
  },
  TOTAL_COMPANIES: {
    id: 'CompanyListPage.TOTAL_COMPANIES',
    defaultMessage: 'Gesamtzahl Firmen',
  },
  ACTIVE_USERS: {
    id: 'CompanyListPage.ACTIVE_USERS',
    defaultMessage: 'Aktive Nutzer',
  },
  TOTAL_CUSTOMERS: {
    id: 'CompanyListPage.TOTAL_CUSTOMERS',
    defaultMessage: 'Kunden insgesamt',
  },
  SEARCH: {
    id: 'CompanyListPage.SEARCH',
    defaultMessage: 'Suchen...',
  },
  ONLY_ACTIVE: {
    id: 'CompanyListPage.ONLY_ACTIVE',
    defaultMessage: 'Nur aktive anzeigen',
  },
});

class CompanyListPageComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: '',
            showOnlyActive: false
        };
    }

    componentWillMount() {
        const { user } = this.props;
        if (!user.is_admin && user.company_count === 1) {
            this.props.replace(`/company/${user.company_id}/`);
        } else {
            this.props.companyListLoad();
        }
    }

    handleSearchChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    render() {
        const { user, error, results, intl: { formatMessage } } = this.props;
        const { filter } = this.state;
        
        if (error) {
            return <NotFound />;
        }
        if (!results) {
            return <div />;
        }

        let displayResults = results;
        if (this.state.showOnlyActive) {
            displayResults = results.filter(comp => !comp.isExpired);
        }

        // Calculate KPIs
        const totalCompanies = displayResults.length;
        const totalUsers = displayResults.reduce((acc, comp) => acc + (comp.user_count || 0), 0);
        const totalCustomers = displayResults.reduce((acc, comp) => acc + (comp.customer_count || 0), 0);

        return (
            <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%', boxSizing: 'border-box' }}>
              <NavBarConfig
                companyList
                currentRouteName={this.props.routes[this.props.routes.length - 1].name}
              />
              
              <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
                  <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                    {formatMessage(messages.ADMIN_DASHBOARD)}
                  </h2>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', color: 'var(--text-color)', fontSize: '14px', fontWeight: 'bold' }}>
                      <input 
                        type="checkbox" 
                        checked={this.state.showOnlyActive} 
                        onChange={(e) => this.setState({ showOnlyActive: e.target.checked })} 
                        style={{ transform: 'scale(1.2)', cursor: 'pointer' }}
                      />
                      {formatMessage(messages.ONLY_ACTIVE)}
                    </label>
                    <div style={{ position: 'relative' }}>
                      <i className="fa fa-search" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                      <input
                        style={{ padding: '10px 16px 10px 40px', borderRadius: '8px', border: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', color: 'var(--text-color)', outline: 'none', width: '250px', fontSize: '14px' }}
                        type="text"
                        placeholder={formatMessage(messages.SEARCH)}
                        value={filter}
                        onChange={this.handleSearchChange}
                      />
                    </div>
                  </div>
                </div>

                {/* KPI Cards Row */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px', marginBottom: '32px' }}>
                  <div style={{ backgroundColor: 'var(--panel-bg)', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px var(--panel-shadow)', border: '1px solid var(--panel-border)', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
                      <i className="fa fa-building" />
                    </div>
                    <div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase' }}>{formatMessage(messages.TOTAL_COMPANIES)}</div>
                      <div style={{ color: 'var(--text-color)', fontSize: '28px', fontWeight: 'bold', lineHeight: '1' }}>{totalCompanies}</div>
                    </div>
                  </div>
                  
                  <div style={{ backgroundColor: 'var(--panel-bg)', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px var(--panel-shadow)', border: '1px solid var(--panel-border)', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: 'rgba(34, 197, 94, 0.1)', color: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
                      <i className="fa fa-users" />
                    </div>
                    <div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase' }}>{formatMessage(messages.ACTIVE_USERS)}</div>
                      <div style={{ color: 'var(--text-color)', fontSize: '28px', fontWeight: 'bold', lineHeight: '1' }}>{totalUsers}</div>
                    </div>
                  </div>

                  <div style={{ backgroundColor: 'var(--panel-bg)', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px var(--panel-shadow)', border: '1px solid var(--panel-border)', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
                      <i className="fa fa-address-book" />
                    </div>
                    <div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase' }}>{formatMessage(messages.TOTAL_CUSTOMERS)}</div>
                      <div style={{ color: 'var(--text-color)', fontSize: '28px', fontWeight: 'bold', lineHeight: '1' }}>{totalCustomers}</div>
                    </div>
                  </div>
                </div>

                {/* Company Table */}
                <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                  <CompanyList items={displayResults} filter={filter} />
                </div>
              </div>
            </div>
        );
    }
}

export default connect(
    state => state.companyList,
    { companyListLoad: companyList.load, replace }
)(injectIntl(CompanyListPageComp));
